import { useTranslation } from 'react-i18next';



export const GridHeader = () => {
	const { t } = useTranslation('admin');

	return (
		<>
			<div className='app-grid-header centered-header'>
				<p>{t('pages.articleList.columns.id')}</p>
			</div>
			
			<div className='app-grid-header centered-header'>
				<p>{t('pages.articleList.columns.name')}</p>
			</div>

			<div className='app-grid-header centered-header'>
				<p>{t('pages.articleList.columns.url')}</p>
			</div>

			<div className='app-grid-header centered-header'>
			</div>
		</>
	)
}